export default {
    initialize: function () {
        window.linkId = getParamValue('id')
        window.title = getParamValue('title')

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }
    },
}
